import React from "react";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import DOMPurify from "dompurify";

const DEFAULT_ANSWER_POINTS = { a: 1, b: 2, c: 3, d: 4 };

const getTotalScore = (answers, answerPoints) =>
  answers.reduce((sum, { answer_ident }) => {
    const points = answerPoints[answer_ident?.toLowerCase()];
    return sum + (points ?? 0);
  }, 0);

const getPersonaByScore = (personas, totalScore) =>
  personas.find(
    (persona) =>
      totalScore >= persona.minScore && totalScore <= persona.maxScore,
  );

export default function ScoreRangePersonaContent({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;
  const isUltraInsider =
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");

  const currentStep = gameQuestionsQuery.content[currentQuestion];
  const answerPoints =
    gameQuestionsQuery.content[currentQuestion].answerPoints ??
    DEFAULT_ANSWER_POINTS;
  const totalScore = getTotalScore(answers, answerPoints);
  const persona = getPersonaByScore(currentStep.answers, totalScore);

  const handleNextButtonClick = () => {
    const currentQuestionIdent = currentStep.ident;

    setAnswers((prevAnswers) => {
      const alreadyAnswered = prevAnswers.find(
        (a) => a.question_ident === currentQuestionIdent,
      );

      if (!alreadyAnswered) {
        return [
          ...prevAnswers,
          {
            question_ident: currentQuestionIdent,
            answer_ident: persona?.ident ?? "null",
          },
        ];
      }

      return prevAnswers;
    });

    if (gameQuestionsQuery.content.length === currentQuestion + 1) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  return (
    <section
      className={`game-page quiz-mechanics ${ident} ${
        isUltraInsider ? "ultra-insider" : ""
      }`}
    >
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentQuestion / gameQuestionsQuery.content.length}
            />

            <div className="content-info-wrapper">
              <div
                className="persona-content"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(persona.answer)}}
              />
            </div>
          </div>
          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            <div className="img-wrapper">
              <img
                src={currentStep[width < 1020 ? "mobileImg" : "desktopImg"]}
                alt=""
              />
              {currentStep?.sideImageCopy && (
                <p
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(currentStep.sideImageCopy),
                  }}
                />
              )}
            </div>
            {XGA && (
              <StickyContent>
                <div className="desktop-buttons">
                  <Button action={handleNextButtonClick}>
                    {currentStep.nextButtonCopy ?? "Nächste"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        <StickyButton action={handleNextButtonClick}>
          {currentStep.nextButtonCopy ?? "Nächste"}
        </StickyButton>
      )}
    </section>
  );
}
